module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_nara-a2ad01aea6bdf3287dcb996212a2fa36.png";